var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"nf79lw4uGjbYiXAYoLz_X"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["we-share-wine@todaytomorrow-ji"]={id:"nf79lw4uGjbYiXAYoLz_X"};
      